const APIOtherProjectRequest = {};

APIOtherProjectRequest["getAllOtherProjects"] = async (accessToken) => {
	try {
		const response = await fetch('/api/other-project', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getOtherProjectById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getAllProjectARBOByProjectId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/arbo-beneficiary/project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getProjectARBOByProjectId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/arbo-beneficiary/project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getAllProjectFarmerByProjectId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/farmer-beneficiary/project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getProjectFarmerByProjectId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/farmer-beneficiary/project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["getOtherProjectById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/other-project/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["addOtherProject"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/other-project', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["addProjectARBOByProjectId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/other-project/arbo-beneficiary/project/' + id, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["addProjectFarmerByProjectId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/other-project/farmer-beneficiary/project/' + id, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["editOtherProjectById"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/other-project/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["editProjectARBOByProjectId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/other-project/arbo-beneficiary/project/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOtherProjectRequest["editProjectFarmerByProjectId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/other-project/farmer-beneficiary/project/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIOtherProjectRequest
